/* eslint-disable react/prop-types */
import React from 'react';
import { Skeleton } from './ui';

const Loading = ({ type = 'default' }) => {
  if (type === 'page') {
    return (
      <div
        className="min-h-screen space-y-6 bg-muted p-6"
        role="status"
        aria-label="Loading page"
      >
        <Skeleton className="h-8 w-56" />
        <div className="grid gap-4 md:grid-cols-3">
          {[1, 2, 3].map(item => (
            <Skeleton key={item} className="h-28 w-full" />
          ))}
        </div>
        <Skeleton className="h-72 w-full" />
      </div>
    );
  }

  if (type === 'table') {
    return (
      <div className="space-y-3" role="status" aria-label="Loading table">
        <Skeleton className="h-10 w-full" />
        {[1, 2, 3, 4, 5, 6].map(item => (
          <div key={item} className="flex gap-3">
            <Skeleton className="h-8 flex-1" />
            <Skeleton className="h-8 flex-1" />
            <Skeleton className="h-8 w-24" />
          </div>
        ))}
      </div>
    );
  }

  if (type === 'bar') {
    return (
      <div
        className="max-w-xs space-y-3"
        role="status"
        aria-label="Loading data"
      >
        {[...Array(10)].map((_, i) => (
          <Skeleton key={i} className="h-4 w-full" />
        ))}
      </div>
    );
  }

  if (type === 'inline') {
    return (
      <span role="status" aria-label="Loading" className="inline-flex w-16">
        <Skeleton className="h-3 w-full bg-current/20" />
      </span>
    );
  }

  if (type === 'csv') {
    return (
      <div className="space-y-3" role="status" aria-label="Loading file data">
        <Skeleton className="h-5 w-1/3" />
        {[1, 2, 3, 4].map(item => (
          <Skeleton key={item} className="h-8 w-full" />
        ))}
      </div>
    );
  }

  if (type === 'retention' || type === 'pie' || type === 'spline') {
    return (
      <div className="space-y-4" role="status" aria-label="Loading chart">
        <Skeleton className="h-5 w-40" />
        <Skeleton className="h-64 w-full" />
      </div>
    );
  }

  return (
    <div
      className={type === 'card' ? 'space-y-3' : 'min-h-72 space-y-3'}
      role="status"
      aria-label="Loading content"
    >
      <Skeleton className="h-5 w-1/3" />
      <Skeleton className={type === 'card' ? 'h-20 w-full' : 'h-40 w-full'} />
    </div>
  );
};

export default Loading;
